import React from 'react';
import { ITextAsProps } from '../../../../../sp-types/routeDetailsType';

export const RouteDetailsPlainText: React.FC<ITextAsProps> = ({ text }) => {
  return <div className="text-sm  text-secondary">{text}</div>;
};
